import { render, staticRenderFns } from "./ViewEmployeeCustomDocumentStatus.vue?vue&type=template&id=25bbd766&scoped=true"
import script from "./ViewEmployeeCustomDocumentStatus.vue?vue&type=script&lang=js"
export * from "./ViewEmployeeCustomDocumentStatus.vue?vue&type=script&lang=js"
import style0 from "./ViewEmployeeCustomDocumentStatus.vue?vue&type=style&index=0&id=25bbd766&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bbd766",
  null
  
)

export default component.exports